import { Thumbmark } from '@thumbmarkjs/thumbmarkjs';
import { LocalStorage } from '../constants/storage';

/**
 * Browser fingerprinting utility.
 *
 * Uses ThumbmarkJS to derive a stable per-browser id and caches it in localStorage under `pp_browser_fp`.
 */

const STORAGE_KEY = LocalStorage.BrowserFingerprint;

let pendingFingerprint: Promise<string> = null;

export function getCachedBrowserFingerprint(): string {
  if (typeof window === 'undefined') return '';
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch {}
  return '';
}

export async function generateBrowserFingerprint(): Promise<string> {
  if (typeof window === 'undefined') return '';

  const cached = getCachedBrowserFingerprint();
  if (cached) return cached;

  if (!pendingFingerprint) {
    pendingFingerprint = computeBrowserFingerprint().finally(() => {
      pendingFingerprint = null;
    });
  }

  return pendingFingerprint;
}

async function computeBrowserFingerprint(): Promise<string> {
  try {
    const tm = new Thumbmark();
    const result = await tm.get();
    const rawThumbmark = result?.thumbmark ? String(result.thumbmark) : '';
    if (!rawThumbmark) return '';

    try {
      localStorage.setItem(STORAGE_KEY, rawThumbmark);
    } catch {}

    return rawThumbmark;
  } catch {}

  return '';
}
